import { Button, Tooltip } from "antd"
import { EditFilled, DeleteFilled } from "@ant-design/icons"
import DataTable from "../../../components/DataTable/DataTable"
import SURVEY_SECTIONS_TABLE_COLUMNS from "../const/SURVEY_SECTIONS_TABLE_COLUMNS"
import { SurveySection } from "../../../../domain/entities/SurveySection"
import { useContainerInjection } from "../../../hooks/useContainerInjection"
import { SurveysViewModel } from "../SurveysViewModel"
import DataTableRowsSkeleton from "../../../styledComponents/LoadingSkeletons/DataTableRowsSkeleton"
import { Link } from "react-router-dom"
import { RoutePaths } from "../../../navigation/RoutePaths.enum"
import { toJS } from "mobx"
import { useTranslation } from "react-i18next"

interface SurveySectionsTableProps {
	data: SurveySection[]
}

const SectionsTable = ({ data }: SurveySectionsTableProps) => {
	const viewModel = useContainerInjection<SurveysViewModel>("SurveysViewModel")
	const { t: tTooltips } = useTranslation("toolTips")
	return (
		<DataTable
			loading={viewModel.isLoading}
			tableConfig={{
				sort: viewModel.tableConfig.sort,
				pageSize: viewModel.tableConfig.pageSize
			}}
			renderCustomLoadingComponent={() => <DataTableRowsSkeleton size="lg" />}
			onChange={data => {
				data.sorter &&
					viewModel.setTableConfig({ sort: { order: data.sorter.order, field: data.sorter.field } })
			}}
			onChangePage={(page, pageSize: number, lastPageFetched) => viewModel.setTableConfig({ pageSize })}
			columns={SURVEY_SECTIONS_TABLE_COLUMNS()}
			dataSource={data?.map((surveySection, idx) => {
				return {
					key: surveySection.id,
					id: surveySection.id,
					name: surveySection.name,
					description: surveySection.description,
					order: surveySection.order,
					editButton: (
						<div className="ant-employed">
							<Link
								to={RoutePaths.SURVEY_SECTIONS_EDIT.replace(":id", surveySection.id?.toString() || "")}
								state={{ surveySection: toJS(surveySection) }}
							>
								<Tooltip title={tTooltips("edit")}>
									<EditFilled />
								</Tooltip>
							</Link>
						</div>
					)
				}
			})}
		/>
	)
}

export default SectionsTable
